import React, { Component } from 'react'
import { formatPrice } from 'Helpers/format-helper'

import './confirm-payment-interval-modal.sass'


class ConfirmScanModal extends Component {
  render() {
    const { proration, close, onValidate, offerVersion } = this.props

    const offerName = offerVersion === 'v1' ? 'Scan' : 'Réexpédition'

    return (
      <div className="ConfirmPaymentIntervalModal">
        <div className="content">
          L'offre {offerName} est facturée 10€ HT/mois, soit 120€ HT/an.<br />
          Vous allez être prélevé du prorata pour le reste de la période courante de votre abonnement, soit {formatPrice(proration, true)} HT.<br /><br />
          Confirmer la souscription à l'offre Scan ?
        </div>
        <div className="buttons">
          <button onClick={close} type="button" className="btn valid connexion-btn">
            Annuler
          </button>
          <button
            onClick={() => {
              onValidate()
              close()
            }}
            type="button"
            className="btn valid connexion-btn"
          >
            Valider
          </button>
        </div>
      </div>
    )
  }
}

export default ConfirmScanModal
